import React, { PropsWithChildren, useState } from 'react';
import { Box, Collapse, Typography } from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';

interface Props {
  title?: string;
  icon?: React.ReactNode;
  isExpandable?: boolean;
  isExpanded?: boolean;
}

export const FormSection = ({
  title,
  icon,
  isExpandable = false,
  isExpanded = true,
  children,
}: PropsWithChildren<Props>) => {
  const [isSectionExpanded, setIsSectionExpanded] = useState<boolean>(isExpanded);

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          bgcolor: '#eeeeee',
          padding: '8px 12px',
          cursor: isExpandable ? 'pointer' : 'default',
        }}
        onClick={() => isExpandable && setIsSectionExpanded(!isSectionExpanded)}
      >
        {icon && icon}
        {title && (
          <Typography variant="subtitle2" component="span">
            {title}
          </Typography>
        )}
        {isExpandable && (
          <ExpandMoreIcon
            sx={{
              transform: isSectionExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: '0.5s',
              fontSize: 22,
            }}
          />
        )}
      </Box>
      <Collapse in={isSectionExpanded}>{children}</Collapse>
    </Box>
  );
};
